import { TestimonialSlider } from '../../../js/src/__utils/sliders'
import hideIfOneSlide from '../../../js/src/__utils/hideIfOneSlide'

// GLOBAL APP CONTROLLER
const controller = {
    init() {
        TestimonialSlider.init()
        hideIfOneSlide('.testimonial-slider')
    },
    loaded() {},
    resized() {},
    scrolled() {},
    keyDown(e) {},
    mouseUp(e) {},
}
export default controller
